var getScreenProfile = require('./getScreenProfile'),
    getWindowProfile = require('./getWindowProfile');

function getBrowserProfile() {
  return {
    'cookies'    : ('undefined' !== typeof navigator.cookieEnabled) ? navigator.cookieEnabled : false,
    'codeName'   : navigator.appCodeName,
    'description': getDocumentDescription(),
    'language'   : navigator.language,
    'name'       : navigator.appName,
    'online'     : navigator.onLine,
    'platform'   : navigator.platform,
    'useragent'  : navigator.userAgent,
    'version'    : navigator.appVersion,
    'screen'     : getScreenProfile(),
    'window'     : getWindowProfile()
  }
}

function getDocumentDescription() {
  var el;
  if (document && typeof document.querySelector === 'function') {
    el = document.querySelector('meta[name="description"]');
  }
  return el ? el.content : '';
}

module.exports = getBrowserProfile;



//////////////////
// WEBPACK FOOTER
// ./~/keen-tracking/lib/helpers/getBrowserProfile.js
// module id = 1975
// module chunks = 0